import React from 'react'
import { Elements, StripeProvider } from 'react-stripe-elements'
import CardUI from '../../../widgets/layout/CardUI'
import CreditCardForm from './CreditCardForm'

const CreditCardCreateUI = ({context, paymentMethodCard, stripeApiKey, messageList, onCancelCreateOrUpdateClick, onPaymentSettingsChange}) =>
  <CardUI context={context}>
    {/* StripeProvider, Elements need to wrap CardElement
      CardElement needs to be in a separate file which must have injectStripe */}
    <StripeProvider apiKey={stripeApiKey}>
      <Elements locale={context.locale}>
        <CreditCardForm
          context={context}
          updateMode={paymentMethodCard !== null}
          messageList={messageList}
          onCancelCreateOrUpdateClick={onCancelCreateOrUpdateClick}
          onPaymentSettingsChange={onPaymentSettingsChange}
        />
      </Elements>
    </StripeProvider>
  </CardUI>

export default CreditCardCreateUI
